import {makeAutoObservable} from 'mobx';
import DownloadFile from './DownloadFile';

class Slot {

	type;
	downloads;
	isExpanded;
	selected;
	all;

	constructor(type, downloadData, hydrateDownloadData = true) {
		this.type = type;
		this.all = false;
		this.selected = false;
		this.isExpanded = false;
		if (Array.isArray(downloadData)) {
			this.downloads = hydrateDownloadData ? downloadData.map(fileData => new DownloadFile(
				fileData[0], fileData[1], fileData[2]
			)) : downloadData;
		}
		if (downloadData && downloadData.all) {
			this.all = true;
		}
		makeAutoObservable(this);
	}

	get isEmpty() {
		return !this.downloads || this.downloads.length === 0;
	}

	get isMulti() {
		return this.downloads && this.downloads.length > 1;
	}

	get isSingle() {
		return this.downloads && this.downloads.length === 1;
	}

	get isActive() {
		return !this.isExpanded && this.downloads && !!this.downloads.find(d => d.selected);
	}

	get isUnselected() {
		return this.isSingle && this.downloads.filter(d => d.selected).length === 0;
	}

	get hasDownloads() {
		return this.downloads && this.downloads.length > 0;
	}

	get allSelected() {
		for (const download of this.downloads) {
			if (!download.selected) {
				return false;
			}
		}
		return true;
	}

	toggleSelection(force = null) {
		if (this.downloads) {
			for (const download of this.downloads) {
				download.toggleSelection(force);
			}
		}
	}

	getSelectedForDownload(uri) {
		if (!this.downloads || this.isExpanded) {
			return [];
		}
		return this.downloads.reduce((slotSelections, d) => {
			if (this.downloads[0].selected) {
				slotSelections.push(`/${uri}/${d.uri}`);
			}
			return slotSelections;
		}, []);
	}


}

export default Slot;
